import currency from 'currency.js';

import Component from '../classes/component';
import { CartSummary as CartSummaryType } from '../types/store-types';

const SELECTORS = {
  content: '.content',
  summaries: '.summaries-wrapper',
  subtotal: '.subtotal-wrapper .amount',
  total: '.grand-total-wrapper .amount',
  taxes: '.tax-fees-wrapper',
};

const currencyOpts: currency.Options = {
  symbol: '$',
  decimal: ',',
  pattern: '# !',
};

class CartSummary extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _getFormattedPrice(value: string | number) {
    return currency(Number(value), currencyOpts).format();
  }

  public updateContent({ items, totals }: CartSummaryType) {
    this._getChild('subtotal').innerHTML = this._getFormattedPrice(totals.subtotal);
    this._getChild('total').innerHTML = this._getFormattedPrice(totals.total);

    const fees = totals.fees.map(({ name, amount }) => {
      const listElement = document.createElement('li');
      listElement.innerHTML = `
          <p>${name}</p>
          <p>${this._getFormattedPrice(amount)}</p>`;

      return listElement;
    });

    const taxes = Object.keys(totals.taxes).map(taxName => {
      const listElement = document.createElement('li');
      listElement.innerHTML = `
          <p>${taxName}</p>
          <p>${this._getFormattedPrice(totals.taxes[taxName])}</p>`;

      return listElement;
    });

    this._getChild<HTMLUListElement>('taxes').replaceChildren(...fees, ...taxes);
    this._getChild<HTMLUListElement>('summaries').replaceChildren(
      ...Object.values(items).map(({ quantity, summary }) => {
        const listElement = document.createElement('li');
        listElement.innerHTML = `
            <p class="quantity">${quantity}</p>
            <p>${summary}</p>`;

        return listElement;
      }),
    );
  }

  public blockUi() {
    (jQuery(this._getChild('content')) as any).block({
      message: null,
      overlayCSS: {
        background: '#fff',
        opacity: 0.6,
      },
    });
  }

  public unblockUi() {
    (jQuery(this._getChild('content')) as any).unblock();
  }
}

export default CartSummary;
